module.exports = __webpack_public_path__ + "img/logo.105c08de.png";